// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2U3gX","col":"styles_col__3R5O_","fulfillmentStatus":"styles_fulfillmentStatus__1Z7GF","emailCol":"styles_emailCol__1mxKp"};